export const defaultRichTextElements = {
  strong: (content) => <strong>{content}</strong>,
  em: (content) => <em>{content}</em>,
  newline: <br />,
  br: () => <br />
}
